export const TRUST_DEED2 = {
  value: "2nd_trust_deed",
  name: "2nd Trust Deed",
};

export const TRUST_DEED3 = {
  value: "3rd_trust_deed",
  name: "3rd Trust Deed",
};

const pms_lien_position = [
  {
    value: "1st_trust_deed",
    name: "1st Trust Deed",
  },
  TRUST_DEED2,
  TRUST_DEED3,
];

export default pms_lien_position;



// WEBPACK FOOTER //
// ./src/constants/pms_lien_position.js